import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the Invite Recommendation popup is viewed
 * Event: dental_portal:invite_recommendation:pop_up_viewed
 */
export function fireInviteRecommendationPopUpViewed(): void {
  PosthogService.getInstance().track('dental_portal:invite_recommendation:pop_up_viewed');
}
